export default {
  RFNBO_HYDROGEN: 'RFNBO_HYDROGEN',
  OTHER_RENEWABLE_HYDROGEN: 'OTHER_RENEWABLE_HYDROGEN',
  FOSSIL_HYDROGEN: 'FOSSIL_HYDROGEN',
};
